import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import localeKo from '@angular/common/locales/ko';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { COMPOSITION_BUFFER_MODE, FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { TreeModule } from '@circlon/angular-tree-component';
import { NbDateFnsDateModule } from '@nebular/date-fns';
import {
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbTimepickerModule,
  NbToastrModule,
  NbWindowModule
} from '@nebular/theme';
import { AgGridModule } from "ag-grid-angular";
import { NgJsonEditorModule } from 'ang-jsoneditor';
import { ko } from 'date-fns/locale';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { NgxPanZoomModule } from 'ngx-panzoom';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppInitService } from './app-init.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CacheRouteReuseStrategy } from './cache-router-reuse-strategy';
import { IscanCommmonModule } from './common/common.module';
import { Interceptior } from './interceptor';
import { ContentReleaseModule } from './pages/content-release/content-release.module';
import { LoginModule } from './pages/login/login.module';
import { RegisterModule } from './pages/register/register.module';
import { QuillModule } from 'ngx-quill';

registerLocaleData(localeKo);

export function initialize(initService: AppInitService) {
  return (): Promise<any> => {
    return initService.init();
  }
}
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    LoginModule,
    ContentReleaseModule,
    TreeModule,
    RegisterModule,
    FormsModule,
    NgxPanZoomModule,
    NgJsonEditorModule,
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
    AgGridModule.withComponents([]),
    IscanCommmonModule,
    NgxJsonViewerModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbTimepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbDateFnsDateModule.forRoot({
      format: "yyyy-MM-dd",
      parseOptions: { locale: ko },
      formatOptions: { locale: ko },
    }),
    QuillModule.forRoot(
      {
        modules: {
          syntax: false,
          toolbar: []
        }
      }
    ),
  ],
  providers: [
    AppInitService,
    {
      provide: LOCALE_ID,
      useValue: 'ko-KR'
    },
    {
      provide: COMPOSITION_BUFFER_MODE,
      useValue: false,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Interceptior,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initialize,
      deps: [AppInitService],
      multi: true,
    },
    {
      provide: RouteReuseStrategy,
      useClass: CacheRouteReuseStrategy,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
